import React from 'react';
import {
  Box,
  Card,
  Button,
  TextField,
  MenuItem,
  Typography,
  Tooltip
} from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { format } from 'date-fns';
import Chart from './chart';
import { ChartOptions_pie } from './ChartOptions';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

const salesValueFormatter = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 });

let d = new Date();
const getISODay = d => (d.getDay() + 6) % 7 + 1;

let today = format(d, 'yyyy-MM-dd');
let yesterday = format(new Date(new Date(d).setDate(d.getDate() - 1)), 'yyyy-MM-dd');
let d1Month = format(new Date(d.getFullYear(), d.getMonth(), 1), 'yyyy-MM-dd');
let d1Week = format(new Date(new Date(d).setDate(d.getDate() - getISODay(d) + 1)), 'yyyy-MM-dd');

function addDays(date, days) {
  if (date) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    result = format(result, 'yyyy-MM-dd');
    return result;
  }
}

const period = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'custom', label: 'Custom' }
];

export const iconMap = {};

class SalesYTDCategoryChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      salescategory_list: [],
      dateFrom: today,
      dateTo: today,
      location: 0,
      delivery: 2,
      sx_hidden: { display: 'none' },
      value: "1",
      locations: [{ 'iref': 0, 'name': "All Locations" }],
      deliverys: [{ 'iref': 2, 'name': "All" }, { 'iref': 0, 'name': "Restaurant" }, { 'iref': 1, 'name': "Delivery" }, { 'iref': 3, 'name': "App Clients" }],
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);
    this.selectPeriod = this.selectPeriod.bind(this);
    this.selectDelivery = this.selectDelivery.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {
      "location": this.state.location,
      "delivery": this.state.delivery,
      "dateFrom": this.state.dateFrom,
      "dateTo": this.state.dateTo
    };

    let data = BackofficeReportsApi.getSalesByCategory(this.state.client, queryData);

    if (data) {
      this.setState({ salescategory_list: data });
    }

    this.setState({ filterData: queryData });

    let locations = BackofficeReportsApi.getLocations(this.state.client);
    this.setState({ locations: locations.locations });
  }

  doSync() {
    this.getData();
  }

  addDateFrom = (event) => {
    this.setState({ dateFrom: event.target.value });
    this.setState({ dateTo: event.target.value });
  }

  addDateTo = (event) => {
    this.setState({ dateTo: event.target.value });
  }

  selectPeriod = (event) => {
    switch (event.target.value) {
      case "today":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: today }, function () {});
        this.setState({ dateTo: today }, function () {
          this.doSync();
        });
        break;

      case "yesterday":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: yesterday }, function () {});
        this.setState({ dateTo: yesterday }, function () {
          this.doSync();
        });
        break;

      case "week":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: d1Week }, function () {});
        this.setState({ dateTo: today }, function () {
          this.doSync();
        });
        break;

      case "month":
        this.setState({ sx_hidden: { display: 'none' } });
        this.setState({ dateFrom: d1Month }, function () {});
        this.setState({ dateTo: today }, function () {
          this.doSync();
        });
        break;

      default:
        this.setState(
          { sx_hidden: {} },
          function () {
            this.doSync();
          }
        );
    }
  }

  selectLocation = (event) => {
    this.setState(
      { location: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  selectDelivery = (event) => {
    this.setState(
      { delivery: event.target.value },
      function () {
        this.doSync();
      }
    );
  }

  render() {
    let locations = [{ 'iref': 0, 'name': "All Locations" }];

    if (this.state.locations) {
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = { 'iref': fData.iref, 'name': fData.name };
        locations.push(myData);
      });
    }

    let deliverys = [
      { 'iref': 2, 'name': "All" },
      { 'iref': 0, 'name': "Restaurant" },
      { 'iref': 1, 'name': "Delivery" },
      { 'iref': 3, 'name': "App Clients" }
    ];

    let categoryLabels = [];
    let categoryData = [];

    if (this.state.salescategory_list) {
      if (this.state.salescategory_list.result) {
        Object.keys(this.state.salescategory_list.result).forEach(key => {
          let fData = this.state.salescategory_list.result[key];
          categoryLabels.push(fData.name);
          categoryData.push(Number(fData.value));
        });
      }
    }

    const chartHeight =
      window.innerWidth < 600
        ? 300
        : window.innerWidth < 1200
          ? 340
          : 380;

    const controlSx = {
      '& .MuiInputBase-root': {
        height: 36,
        borderRadius: '12px',
        fontSize: {
          xs: '0.82rem',
          sm: '0.88rem',
        },
        bgcolor: '#fff',
      },
      '& .MuiInputLabel-root': {
        fontSize: {
          xs: '0.76rem',
          sm: '0.82rem',
        },
      },
      '& .MuiSelect-select': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    };

    const smallControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 22px)',
        sm: 120,
      },
    };

    const mediumControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 22px)',
        sm: 170,
      },
    };

    const dateControlSx = {
      ...controlSx,
      width: {
        xs: 'calc(50% - 24px)',
        sm: 130,
      },
    };

    return (
      <Card
        variant="outlined"
        sx={{
          position: 'relative',
          width: '100%',
          height: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          maxHeight: {
            xs: 600,
            sm: 600,
            md: 620,
            lg: 640,
          },
          minHeight: 0,
          borderRadius: {
            xs: '14px',
            sm: '16px',
          },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          bgcolor: '#fff',
        }}
      >
        <Box
          sx={{
            px: {
              xs: 0.75,
              sm: 1,
            },
            py: {
              xs: 0.65,
              sm: 0.85,
            },
            flexShrink: 0,
            borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
            bgcolor: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: {
                xs: 'stretch',
                sm: 'center',
              },
              justifyContent: 'space-between',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  color: '#1a237e',
                  fontWeight: 800,
                  fontSize: {
                    xs: '0.9rem',
                    sm: '1rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Category Sales
              </Typography>

              <Typography
                sx={{
                  mt: 0.15,
                  color: '#64748b',
                  fontWeight: 600,
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                  },
                  lineHeight: 1.2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Sales distribution by category
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 0.85,
              display: 'flex',
              alignItems: 'center',
              gap: {
                xs: 0.75,
                sm: 1,
              },
              flexWrap: 'wrap',
              maxHeight: {
                xs: 122,
                sm: 96,
              },
              overflowY: 'auto',
              overflowX: 'hidden',
              pr: 0.25,
              '&::-webkit-scrollbar': {
                width: 8,
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(15, 23, 42, 0.18)',
                borderRadius: 999,
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(15, 23, 42, 0.04)',
              },
            }}
          >
            <TextField
              id="standard-select-period"
              select
              defaultValue="today"
              variant="outlined"
              size="small"
              sx={smallControlSx}
              onChange={this.selectPeriod}
            >
              {period.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-location"
              select
              defaultValue="0"
              variant="outlined"
              size="small"
              sx={mediumControlSx}
              onChange={this.selectLocation}
            >
              {locations.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              id="standard-select-delivery"
              select
              defaultValue="2"
              variant="outlined"
              size="small"
              sx={smallControlSx}
              onChange={this.selectDelivery}
            >
              {deliverys.map((option) => (
                <MenuItem key={option.iref} value={option.iref}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <Box
              sx={{
                ...this.state.sx_hidden,
                alignItems: 'center',
                gap: 0.75,
                flexWrap: 'wrap',
              }}
            >
              <TextField
                size="small"
                id="date-from"
                label="From"
                type="date"
                value={this.state.dateFrom}
                variant="outlined"
                sx={dateControlSx}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: "2020-01-01",
                  style: {
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateFrom}
              />

              <TextField
                size="small"
                id="date-to"
                label="To"
                type="date"
                value={this.state.dateTo}
                variant="outlined"
                sx={dateControlSx}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: "2020-01-01",
                  max: addDays(this.state.dateFrom, 50),
                  style: {
                    paddingRight: 5,
                    paddingLeft: 5
                  }
                }}
                onChange={this.addDateTo}
              />

              <Tooltip title="Refresh">
                <Button
                  color="inherit"
                  onClick={() => this.doSync()}
                  variant="contained"
                  sx={{
                    minWidth: 36,
                    width: 36,
                    height: 36,
                    p: 0,
                    flexShrink: 0,
                    borderRadius: '12px',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none',
                    },
                  }}
                >
                  <AutorenewIcon fontSize="small" />
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            flex: '1 1 auto',
            minHeight: 0,
            overflow: 'auto',
            bgcolor: '#fff',
            p: {
              xs: 0.5,
              sm: 0.75,
            },
            '&::-webkit-scrollbar': {
              height: 8,
              width: 8,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(15, 23, 42, 0.18)',
              borderRadius: 999,
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'rgba(15, 23, 42, 0.04)',
            },
          }}
        >
          <Box
            sx={{
              borderRadius: '14px',
              border: '1px solid rgba(15, 23, 42, 0.06)',
              overflow: 'hidden',
              bgcolor: '#fff',
              width: '100%',
              height: '100%',
              minHeight: {
                xs: 320,
                sm: 360,
                md: 400,
                lg: 430,
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: 360,
                  sm: 520,
                  md: 640,
                  lg: 720,
                },
                mx: 'auto',
              }}
            >
              {categoryData.length > 0 ? (
                <Chart
                  height={chartHeight}
                  type="pie"
                  series={categoryData}
                  labels={categoryLabels}
                  options={{
                    ...ChartOptions_pie,
                    labels: categoryLabels,
                    tooltip: {
                      ...ChartOptions_pie.tooltip,
                      y: { formatter: (value) => salesValueFormatter.format(value) },
                    },
                  }}
                  width="100%"
                />
              ) : (
                <Typography
                  sx={{
                    color: 'text.secondary',
                    fontSize: {
                      xs: '0.86rem',
                      sm: '0.92rem',
                    },
                  }}
                >
                  No data
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Card>
    );
  }
}

export default SalesYTDCategoryChart;
